import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-solution-based-fabrics',
  templateUrl: './solution-based-fabrics.component.html',
  styleUrls: ['./solution-based-fabrics.component.css']
})
export class SolutionBasedFabricsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
